import { createFileRoute } from '@tanstack/react-router'
import { IdentityRecordTab } from '@/components/identities/identity-tabs'

export const Route = createFileRoute('/o/$org/identities/$id/identity')({
  component: () => <IdentityRecordTab identityId={Route.useParams().id} />,
})
